import { render, staticRenderFns } from "./app-table.vue?vue&type=template&id=dab388ce&scoped=true"
import script from "./app-table.vue?vue&type=script&lang=js"
export * from "./app-table.vue?vue&type=script&lang=js"
import style0 from "./app-table.vue?vue&type=style&index=0&id=dab388ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab388ce",
  null
  
)

export default component.exports